import { produce } from 'immer';
import * as types from './thirdPartyImportsTypes';
import createReducer from '../utils/createReducer';

const initialState = {
    records: [],
    totalRecords: 0,
    loading: true,
};

const actionHandlers = {
    [types.GET_INTEGRATIONS.REQUEST]: produce((draft) => {
        draft.loading = true;
    }),
    [types.GET_INTEGRATIONS.SUCCESS]: produce(
        (draft, { total, integrations }) => {
            draft.records = integrations;
            draft.totalRecords = total;
            draft.loading = false;
        }
    ),
    [types.GET_INTEGRATIONS.FAILURE]: produce((draft) => {
        draft.loading = false;
    }),
    [types.RESET_INTEGRATIONS]: produce((draft) => {
        draft.records = [];
        draft.totalRecords = 0;
        draft.loading = true;
    }),
};

export default createReducer(initialState, actionHandlers);
